import React from 'react';
import { motion } from 'framer-motion';
import { MatrixRain } from '../components/MatrixRain';
import { Cpu, Zap } from 'lucide-react';
interface GatewayPageProps {
  onEnter: () => void;
}
export function GatewayPage({
  onEnter
}: GatewayPageProps) {
  return <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-matrix-bg overflow-hidden" data-id="element-331">
      {/* Background Elements */}
      <MatrixRain data-id="element-332" />

      {/* Robot/Matrix Background Image Overlay */}
      <div className="absolute inset-0 z-1 opacity-25 pointer-events-none" data-id="element-333">
        <img src="https://images.unsplash.com/photo-1531746790731-6c087fecd65a?q=80&w=2000&auto=format&fit=crop" alt="Matrix Robot Background" className="w-full h-full object-cover mix-blend-screen filter hue-rotate-90 contrast-125 saturate-150" data-id="element-334" />
        <div className="absolute inset-0 bg-gradient-to-t from-matrix-bg via-matrix-bg/30 to-matrix-bg" data-id="element-335" />
      </div>

      {/* Main Content */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1,
      delay: 0.5
    }} className="relative z-10 max-w-2xl mx-auto text-center px-4" data-id="element-336">
        <h1 className="text-4xl md:text-6xl font-matrix font-bold text-matrix-text mb-12 text-glow leading-tight" data-id="element-337">
          ¿Listo para resetear tu <br data-id="element-338" />
          <span className="text-matrix-primary" data-id="element-339">Mente Maestra</span>?
        </h1>

        <motion.button onClick={onEnter} whileHover={{
        scale: 1.05,
        boxShadow: '0 0 30px rgba(0, 255, 65, 0.4)'
      }} whileTap={{
        scale: 0.95
      }} className="group relative inline-flex items-center justify-center px-16 py-6 bg-black/80 border-2 border-matrix-primary text-matrix-primary font-matrix text-2xl md:text-3xl font-bold tracking-widest uppercase overflow-hidden transition-all duration-300" data-id="element-340">
          {/* Circuit Board Pattern Background */}
          <div className="absolute inset-0 opacity-20 pointer-events-none" data-id="element-341">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-342">
              <pattern id="circuit" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-343">
                <path d="M10 10h20v20h-20z" fill="none" stroke="#00ff41" strokeWidth="1" data-id="element-344" />
                <circle cx="10" cy="10" r="2" fill="#00ff41" data-id="element-345" />
                <circle cx="30" cy="30" r="2" fill="#00ff41" data-id="element-346" />
                <path d="M10 10l10 10M30 30l-10-10" stroke="#00ff41" strokeWidth="1" data-id="element-347" />
              </pattern>
              <rect width="100%" height="100%" fill="url(#circuit)" data-id="element-348" />
            </svg>
          </div>

          {/* Scanline effect */}
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-matrix-primary/10 to-transparent translate-y-[-100%] group-hover:translate-y-[100%] transition-transform duration-1000" data-id="element-349" />

          <span className="relative z-10 flex items-center gap-4" data-id="element-350">
            <Cpu className="w-6 h-6 animate-pulse" data-id="element-351" />
            SÍ
            <Zap className="w-6 h-6 animate-pulse" data-id="element-352" />
          </span>

          {/* Corner accents */}
          <div className="absolute top-0 left-0 w-3 h-3 border-t-2 border-l-2 border-matrix-primary" data-id="element-353" />
          <div className="absolute top-0 right-0 w-3 h-3 border-t-2 border-r-2 border-matrix-primary" data-id="element-354" />
          <div className="absolute bottom-0 left-0 w-3 h-3 border-b-2 border-l-2 border-matrix-primary" data-id="element-355" />
          <div className="absolute bottom-0 right-0 w-3 h-3 border-b-2 border-r-2 border-matrix-primary" data-id="element-356" />
        </motion.button>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.5,
        duration: 0.8
      }} className="mt-8 text-matrix-red text-sm font-mono font-bold tracking-widest" data-id="element-357">
          [ ACCESO CLASIFICADO ]
        </motion.p>
      </motion.div>
    </div>;
}